import { IconHighway16 } from '@cian/ui-kit';
import { HighwayItem } from 'shared/components/TransportAccessibility';
import { IHighwayInfo } from 'shared/types/houseInfo/highway';
import { getValue } from './getValue';

const HIGHWAY_TYPE_MAP: Map<number, string> = new Map([
  [1, 'МКАД'],
  [4593, 'МКАД'],
  [2, 'КАД'],
  [4588, 'КАД'],
]);

export const renderHighways = (highways: IHighwayInfo[], regionId: number) =>
  highways.map(({ distance, id }) => {
    const highwayType = getValue(HIGHWAY_TYPE_MAP.get(regionId), 'центра');
    const text = `${Math.round(Number(distance))} км от ${highwayType}`;

    return <HighwayItem icon={IconHighway16} text={text} key={`highway${id}`} />;
  });
